import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";
import { track } from "../utils";
import { queueEvents } from "../utils/handle-track-queue.utils";

interface IState {
  blocked: boolean;
  initialized: boolean;
  initializedTypes: {
    user: boolean;
    account: boolean;
    properties: boolean;
  };
}

interface IActions {
  setBlocked: (blocked: boolean) => void;
  setInitializedType: (type: "user" | "account" | "properties") => void;
  reset: () => void;
}

const initState: IState = {
  blocked: false,
  initialized: false,
  initializedTypes: {
    user: false,
    account: false,
    properties: false,
  },
};

let GLOBAL_INIT = false;

export const useAnalyticsStore = create<IState & IActions>((set, get) => ({
  ...initState,

  setBlocked: (blocked) => set({ blocked }),

  setInitializedType: (type: "user" | "account" | "properties") => {
    const { initializedTypes } = get();
    const nextState = { ...initializedTypes, [type]: true };
    const initialized = Object.values(nextState).every((value) => value);
    set({
      initializedTypes: nextState,
      initialized,
    });

    if (initialized && !GLOBAL_INIT) {
      GLOBAL_INIT = true;
      track("open app");
      queueEvents.handleClearTrackQueue();
    }
  },

  reset: () => set(initState),
}));

export const useAnalyticsStoreShallow = <U>(
  selector: (store: IState & IActions) => U,
) => useAnalyticsStore(useShallow(selector));
